import React, { Component } from 'react'
import { Link } from "react-router-dom"
import PropTypes from 'prop-types'
import getBoxStatus from "../../../vietnameses/getBoxStatus"
import timeHumanize from "../../helpers/timeHumanize"
import classNames from 'classnames'
import { listLocal, listLineship } from "../../helpers/filtersTable"
import Button from 'antd/lib/button'
import { ReactComponent as IconBarCode } from "../../../assets/icon/icon-barcode.svg"
import { Modal, Popover, Checkbox, Tooltip } from 'antd'
import formatNumber from '../../helpers/formatNumber'
import listLineShipBox from '../../helpers/listLineShipBox'
import getBoxShipLabelUrl from '../../helpers/getBoxShipLabelUrl'

class BoxItem extends Component {
    state = {
        showbarcode: false,
        showShipLabel: false,
        showShipFrom: false,
        showShipTo: false
    }

    _ShippingCarrierName = (carrier) => {
        if (!!carrier) {
            const mappingCarriers = [
                ...listLocal,
                { value: 'usps_mn_ib_blue', name: 'USPS MN/IB Blue' },
                { value: 'ib_blue_usps_mn', name: 'IB Blue/USPS MN' },
                { value: 'hw_yun', name: "HW_YUN" },
                { value: 'hq', name: "HQ" },
                { value: 'jt_usps', name: "JT_USPS" },
                { value: 'ns_usps', name: "NS_USPS" },
            ]
            const shippingName = mappingCarriers.filter(item => item.value === carrier)

            return shippingName[0]
        }
    }

    _LineShipName = (lineShip) => {
        if (!!lineShip) {
            const mappingLineShips = [
                ...listLineship,
                { value: 'usps_mn_ib_blue', name: 'USPS-IB' },
                { value: 'ib_blue_usps_mn', name: 'IB-USPS' },
                { value: 'hw_yun', name: "HW_YUN" },
                { value: 'hq', name: "HQ" },
                { value: 'jt_usps', name: "JT_USPS" },
                { value: 'ns_usps', name: "NS_USPS" },
            ]
            const lineShipName = mappingLineShips.filter(item => item.value === lineShip)

            return lineShipName[0]
        }
    }

    showModal = () => {
        this.setState({ showbarcode: true })
    }

    handleCancel = () => {
        this.setState({ showbarcode: false })
    }

    showShipLabelModal = () => {
        this.setState({ showShipLabel: true })
    }

    handleCancelShipLabel = () => {
        this.setState({ showShipLabel: false })
    }

    handleShowShipFrom = (value) => {
        this.setState({ showShipFrom: value })
    }

    handleShowShipTo = (value) => {
        this.setState({ showShipTo: value })
    }

    _handleClickEdit = () => {
        const { id, real_weight, real_height, real_width, real_length } = this.props.box
        const { onGetInfoBox } = this.props
        onGetInfoBox(id, real_weight, real_height, real_width, real_length)
    }

    _isActiveButton = () => {
        const { is_finish_update_fba_info } = this.props.box
        return is_finish_update_fba_info === true
    }

    _detectChecked = () => {
        const { box, selectedItems } = this.props

        return Array.isArray(selectedItems) && !!selectedItems.find(i => i._id === box._id)
    }

    _handleChange = () => {
        const isChecked = this._detectChecked()
        const { box, onChangeSelected } = this.props

        onChangeSelected(box._id, !isChecked)
    }

    render() {
        const { handleChangeSelect } = { ...this.props }
        const {
            _id: boxId,
            id,
            created,
            status,
            closed_at,
            shipped_at,
            total_items,
            total_packages,
            shipping_carrier,
            warehouse_id,
            total_weight,
            tracking_number,
            next_box_code,
            import_tracking_at,
            is_fba_box,
            orderNumber,
            batch_ship,
            fba_box_label,
            ship_from,
            ship_to,
            real_height,
            real_length,
            real_weight,
            real_width,
            is_fully_boxed,
            box_partner_status,
            box_partner_detail,
            meta,
            isMTLight,
            boxQRData,
            isWoodProduct,
        } = this.props.box

        const { showShipFrom, showShipTo, showbarcode, showShipLabel } = this.state
        // FAC-23949: dùng helper chung để đọc URL ship label (label_ship_details.url || label_url),
        // thống nhất với màn chi tiết lô & màn dán label.
        const shipLabelUrl = getBoxShipLabelUrl(this.props.box)
        const carrierName = this._ShippingCarrierName(shipping_carrier)
        const lineShipName = this._LineShipName(shipping_carrier)
        const isActive = this._isActiveButton()
        let fbaBoxed = ''
        if (is_fba_box) {
            fbaBoxed = is_fully_boxed || total_items === 0 || total_packages === 0 ? '' : 'not-fully-boxed'
        }

        const isChecked = this._detectChecked()
        const LLCStatus = {
            cancel: 'Đã hủy',
            draft: 'Lưu nháp',
            shipping: 'Đang vận chuyển đến US',
            received: 'Đã nhận tại kho US',
            done: 'Hoàn thành',
            processing: 'Đang xử lý',
            error: 'Lỗi',
        }
        const boxQRName = boxQRData && boxQRData.name ? boxQRData.name : lineShipName && lineShipName.name
        return (
            <tr className={classNames("BoxItem", status, fbaBoxed)} key={boxId}>
                <td>
                    <Checkbox id={`BoxColSelection_${boxId}`} checked={isChecked} onChange={this._handleChange} />
                </td>
                <td>
                    <div className='d-flex justify-content-between align-items-center'>
                        {
                            is_fba_box ? <Link to={`/next-boxes-fba/${boxId}`}>#{id}</Link> :
                                <Link to={`/next-boxes/${boxId}`}>#{id}</Link>
                        }
                        {is_fba_box == true &&
                            <Button
                                type={"primary"}
                                className="TagFBA ml-1"
                                size={"small"}
                            >
                                FBA
                            </Button>
                        }
                    </div>
                </td>
                <td className="Total">{total_packages || 0}</td>
                <td className="Total">{total_items || 0}</td>
                <td>
                    <div className='shippingCarrier'>
                        {(shipping_carrier && (warehouse_id || (meta && meta.carrier_name))) &&
                            <span className='cursor-pointer textHover' onClick={() => handleChangeSelect('shipping_carrier', [shipping_carrier])}>
                                {!!meta && !!meta.carrier_name ? meta.carrier_name : ''}{!!warehouse_id && `(${warehouse_id})`}
                            </span>
                        }
                    </div>
                </td>
                <td>
                    <div className='d-flex align-items-center lineship'>
                        {boxQRName &&
                            <span className='cursor-pointer textHover' onClick={() => handleChangeSelect('box_name', [boxQRName])}>{boxQRName}</span>
                        }

                        {isMTLight == true &&
                            <Button
                                type={"primary"}
                                className="TagLight ml-1"
                                size={"small"}
                            >
                                Nhẹ
                            </Button>
                        }
                        {isWoodProduct == true &&
                            <Button
                                type={"primary"}
                                className="TagLight ml-1"
                                size={"small"}
                            >
                                Gỗ
                            </Button>
                        }
                    </div>
                </td>
                <td className="Status">{getBoxStatus(status)}</td>
                <td>{timeHumanize(created) || '--'}</td>
                <td>{timeHumanize(closed_at) || '--'}</td>
                <td>{timeHumanize(shipped_at) || '--'}</td>
                <td>
                    <span
                        className="weight">{formatNumber(real_weight || (total_weight ? total_weight / 1000 : total_weight), { suffix: ' KG' })}</span>
                    {(real_length || real_height || real_width) ? <span className="clearfix" /> : ''}
                    <span className="size">
                        {real_length || ''}{real_length && 'cm x '}{real_width || ''}{real_width && 'cm x '}{real_height || ''}{real_height && 'cm'}
                        <button type="button" onClick={this._handleClickEdit} disabled={isActive}><i
                            className='icon-pencil' /></button>
                    </span>
                </td>
                <td className="TrackingDHL">
                    {tracking_number && <span>Tracking: <span>{tracking_number || '--'}</span></span>}
                    {import_tracking_at &&
                        <span>Ngày ship: <span>{timeHumanize(import_tracking_at) || '--'}</span></span>}
                    {ship_from &&
                        <span>Ship from: <span>
                            <Popover
                                content={ship_from}
                                title="Ship from:"
                                trigger="click"
                                visible={showShipFrom}
                                onVisibleChange={this.handleShowShipFrom}
                            >
                                <a title={ship_from}>
                                    {ship_from.length > 30 ? ship_from.slice(0, 31) + "..." : ship_from}
                                </a>
                            </Popover>
                        </span>
                        </span>}
                    {ship_to &&
                        <span>Ship to: <span>
                            <Popover
                                content={<p>{ship_to}</p>}
                                title="Ship to:"
                                trigger="click"
                                visible={showShipTo}
                                onVisibleChange={this.handleShowShipTo}
                            >
                                <a title={ship_to}>
                                    {ship_to.length > 30 ? ship_to.slice(0, 31) + "..." : ship_to}
                                </a>
                            </Popover>
                        </span>
                        </span>}
                    {next_box_code && <span>Mã thùng: <span>{next_box_code || '--'}</span></span>}
                    {!listLineShipBox.includes(shipping_carrier) && !!box_partner_detail &&
                        <span>LLC: <span>{box_partner_detail.id || '--'}</span></span>}
                    {!listLineShipBox.includes(shipping_carrier) && LLCStatus[box_partner_status] &&
                        <span><span>{LLCStatus[box_partner_status] || '--'}</span></span>}
                    {listLineShipBox.includes(shipping_carrier) && !!box_partner_detail && box_partner_status === 'done' &&
                        <span>{(meta && meta.carrier_name) ? `${meta.carrier_name === 'HW UPS' ? 'HW UPS' : 'HW USPS'}:` : ''} <span>{box_partner_detail.responseData && box_partner_detail.responseData.cartonId ? box_partner_detail.responseData.cartonId : '--'}</span></span>}
                </td>
                <td>
                    {!!orderNumber &&
                        <div
                            className='cursor-pointer textHover'
                            onClick={() => handleChangeSelect('boxNumber', [orderNumber])}
                        >
                            {orderNumber}
                        </div>
                    }
                    {is_fba_box && !!batch_ship && !!batch_ship.id &&
                        <div className="BatchShipId">
                            Lô ship: <Link to={`/batch-ship/${batch_ship._id}`} target="_blank" rel="noopener noreferrer">{batch_ship.id}</Link>
                        </div>
                    }
                </td>
                <td>
                    <div className='d-flex align-items-center BoxLabelIcons'>
                        {
                            is_fba_box && !!fba_box_label &&
                            <Tooltip title="Amazon box label">
                                <a onClick={this.showModal} className='mr-2'>
                                    <IconBarCode />
                                </a>
                            </Tooltip>
                        }
                        {
                            !!shipLabelUrl &&
                            <Tooltip title="Ship label">
                                <a onClick={this.showShipLabelModal} className='ShipLabelIcon'>
                                    <IconBarCode />
                                </a>
                            </Tooltip>
                        }
                    </div>
                    <Modal
                        visible={showbarcode}
                        onCancel={this.handleCancel}
                        footer={[]}
                        width="1000px"
                    >
                        <iframe src={fba_box_label} width={"100%"} height="679" />
                    </Modal>
                    <Modal
                        visible={showShipLabel}
                        onCancel={this.handleCancelShipLabel}
                        footer={[]}
                        width="1000px"
                    >
                        <img
                            src={shipLabelUrl}
                            alt="Ship label"
                            style={{ display: 'block', margin: '0 auto', maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                        />
                    </Modal>
                </td>
            </tr>
        )
    }
}

BoxItem.propTypes = {
    box: PropTypes.object.isRequired,
}

export default BoxItem
